import { LedgerModalController } from './LedgerModalController';
import type { LedgerModalProp } from '../types';
const LedgerModal = <T,>(props: LedgerModalProp<T>) => {
  const { open } = props;
  if (!open) {
    return null;
  } else {
    return <LedgerModalController {...props} />;
  }
};

export { LedgerModal };
